import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService, BiometricService, CampaignAnalyticsService, DeviceService, UserService } from '@app/services';
import { PATH, PATTERNS } from '@app/constants';
import { UserValidators } from '../../../classes/user-validators.class';
import { environment } from 'src/environments/environment';
import { AuthenticationForgotPasswordComponent } from '../authentication-forgot-password/authentication-forgot-password.component';
import { UserInfo, UserType } from '@interfaces/app';
import { ModalService } from '@app/services/modal/modal.service';
import { StorageService } from '@app/services/storage-service/storage-service.service';
import { catchError, map, of, Subscription, switchMap } from 'rxjs';
import { SingularService } from 'src/infra/analytics/singular/singular.service';
declare var cordova: any;

@Component({
  templateUrl: './authentication-login.component.html',
  styleUrls: ['./authentication-login.component.scss'],
})
export class AuthenticationLoginComponent implements OnInit {
  subs: { [prop: string]: Subscription } = {};

  loginForm: FormGroup;

  isWeb = false;

  platformType: 'ios' | 'android' | 'web' = 'web';

  passwordFlag = 'password';

  /** Parametro para redireccionar al formulario de UNE */
  sr: string;
  /** Parametro para redireccionar al modal de promociones */
  prom: string;
  /** Parametros para redireccionar al modal de testimonios */
  ts: string;

  /** Nombre del inversionista en caso de encontrarlo */
  existEmail: {
    name: string;
    fatherSurname: string;
    motherSurname: string;
    valid: boolean;
    email?: string;
  };

  isSaveCredentials: any;
  isNativePlatform: boolean = false;
  emailMobile: string;
  
  isiOSDevice: boolean;

  constructor(
    private fb: FormBuilder,
    private authServ: AuthService,
    private userServ: UserService,
    private router: Router,
    private modal: MatDialog,
    private modalServ: ModalService,
    private activatedRoute: ActivatedRoute,
    private storageServ: StorageService,
    private singularService: SingularService,
    private biometricService: BiometricService,
    private analyticsCampaServ: CampaignAnalyticsService,
    private deviceServ: DeviceService,
  ) {
    this.existEmail = {
      name: '',
      fatherSurname: '',
      motherSurname: '',
      valid: false,
    };
    this.platformType = typeof cordova !== 'undefined' ? 'ios' : 'web';
  }

  get password() {
    return this.loginForm.controls['password'];
  }

  get email() {
    return this.loginForm.controls['email'];
  }

  ngOnInit(): void {

    this.isNativePlatform = this.platformType === 'ios' || this.platformType === 'android';

    if (this.isNativePlatform) {
      this.biometricService.getStoredCredentials().then((credentials) => {
        this.isSaveCredentials = !!credentials;

        if (credentials) {
          const { validEmail, logout, name, fatherSurname, motherSurname } = credentials;
          this.emailMobile = credentials.email;

          if (validEmail === 'true') {
            this.existEmail = { valid: true, name, fatherSurname, motherSurname };
          }

          if (logout === 'false') {
            this.loginWithBiometric();
          }
        }
      });

      if(environment.isMobile) {
        this.subs.d = this.deviceServ.nativeDevice.subscribe(info => {
          this.isiOSDevice = info.operatingSystem === 'ios';
        })
      }

    }


    /** Detectar si la URL tiene parametros para levantar un tickt */
    this.activatedRoute.queryParams.subscribe((r) => {
      this.sr = r.sr;
    });

    /** Detectar su la URL tiene parametros para dejar un testimonio */
    this.activatedRoute.queryParams.subscribe((r) => {
      this.ts = r.ts;
    });

    /** Detectar si la URL tiene parametros para dar de baja su promoción  */
    this.activatedRoute.queryParams.subscribe((r) => {
      this.prom = r.prom;
    });

    this.isWeb = !environment.isMobile;

    this.loginForm = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          UserValidators.patternValidator(PATTERNS.email, {
            validEmail: false,
          }),
        ])
      ),
      password: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(8)])
      ),
    });
  }

  login() {
    if(this.isNativePlatform && this.emailMobile) {
      this.loginForm.controls['email'].setValue(this.emailMobile);
    }

    if (this.loginForm.valid) {

      const { email, password } = this.loginForm.value;

      if(this.isNativePlatform) {
        this.biometricService.getStoredCredentials().then((credentialsActive) => {
          if(credentialsActive) {
            if(email != credentialsActive.email) {
              let emailRemove = credentialsActive.email;
              this.loginAuth(email, password, emailRemove)
            } else {
              this.loginAuth(email, password);
            }
          } else {
            this.loginAuth(email, password);
          }
        })
      } else {
        this.loginAuth(email, password);
      }
    }
  }

  loginAuth(email: string, password: string, emailRemove?: string) {
    this.authServ.login(email, password).pipe(
      switchMap((response) => {
        if (response) {
          return this.userServ.getUserInf();
        }
        return of(null);
      }),
      map((user) => {
       this.singularService.login(this.singularService.getDeviceDefaultID());
       this.singularService.sendEvent('__MONIFIC_INICIO_SESION__', {})

       this.biometricService.isBiometricAvailable().then((isAvailable) => {
          if (isAvailable) {
            if(this.isNativePlatform && emailRemove && this.isSaveCredentials) {
              this.biometricService.deleteCredentials().then(() => {
                this.changeStatusBiometric(emailRemove, false).subscribe((res) => {
                  if(res) {
                    this.isSaveCredentials = false;
                    if(this.isNativePlatform && !this.isSaveCredentials) {
                      this.loginServ(user, email, password);
                    } else {
                      this.redirectAfterLogin(user, email, password);
                    }
                  }
                });
              });
             } else if(this.isNativePlatform && !this.isSaveCredentials) {
              this.loginServ(user, email, password);
             } else {
              this.redirectAfterLogin(user, email, password);
             }
          } else {
            this.saveAnalytics();
            this.redirectAfterLogin(user, email, password);
          }
       })

      }),
      catchError((err) => {
        return of(null);
      })
    ).subscribe();
  }

  loginServ(user: any, email: string, password: string) {
    if (this.isNativePlatform) {
      this.biometricService.askForBiometrics()
        .then((enableBiometrics) => {
          if (enableBiometrics) {
            this.biometricService.authenticateWithBiometrics()
              .then((success) => {
                if (success) {
                  this.biometricService.saveCredentials(email, password, 'false').then(() => {
                    this.changeStatusBiometric(email, true).subscribe((res) => {
                      if (res) {
                        this.redirectAfterLogin(user, email, password);
                      }
                    });
                  });
                }
              })
              .catch(() => { });
          } else {
            this.redirectAfterLogin(user, email, password);
          }
        })
        .catch(() => { });
    } else {
      this.redirectAfterLogin(user, email, password);
    }
  }

  // Función auxiliar para la redirección
  redirectAfterLogin(user: any, email: string, password: string) {
    const lastUrl = localStorage.getItem('lastUrl');
    if (lastUrl) {
      localStorage.removeItem('lastUrl');
      this.router.navigate([lastUrl]);
    } else {
      this.redirectUserDashboard(user, email, password);
    }
  }

  changeStatusBiometric(email: string, status: boolean) {
    return this.authServ.setStatusBiometric(email, status);
  }

  // Función para recargar la página
  refresh(): void {
    if(this.isNativePlatform) {
      this.biometricService.deleteCredentials().then(() => {
        window.location.reload();
      })
    } else {
      window.location.reload();
    }
  }

  /** Verficar si el email que ingresan existe en la base de datos */
  verifyEmail() {
    const { email } = this.loginForm.value;
    this.authServ.verifyExistEmail(email).subscribe((r) => {
      this.existEmail = r;
      if(this.isNativePlatform && r.valid) {
        this.biometricService.saveFullName(r?.name, r?.fatherSurname || '', r?.motherSurname || '', r.valid)
      }
    });
  }

  redirectUserDashboard(user: UserInfo, email: string, password: string) {
    this.redirectDashboard(user.type, user?.stepRegister);
  }

  redirectDashboard(type: UserType, stepRegister?: number) {
    if (this.sr) {
      sessionStorage.setItem('UNE_FORM', '1');
      this.router.navigate([PATH.ROUTE_UNE_INITIALIZE_REQUEST]);
    } else if (this.ts) {
      sessionStorage.setItem('TESTIMONY_FORM', '1');
      this.router.navigate([PATH.ROUTE_TESTIMONY_INITIALIZE_REQUEST]);
    } else if (this.prom) {
      this.modalServ.openModalPromotions();
    } else {
      if(stepRegister < 5 ){
        //Independientemente de que tipo de usuario sea, si no ha acabado el registro, se redirecciona a la pantalla de onboarding
        this.router.navigate([PATH.ROUTE_USER_ONBOARDING]);
      } else {
        if (type === 'd') {
        // DESARROLLADOR
          this.router.navigate([PATH.ROUTE_DEVELOPER]);
        } else {
          // INVERSIONISTA
          this.router.navigate([PATH.ROUTE_DASHBOARD_HOME]);
        }
      }
    }
  }

  forgotPassword() {
    this.modal.open(AuthenticationForgotPasswordComponent, {
      panelClass: 'mnf-modal-container',
      width: '95vw',
      maxWidth: '400px',
      autoFocus: false,
      maxHeight: '95vh',
    });
  }

  /** Función para guardar los datos de analytics */
  saveAnalytics() {
    let source = this.analyticsCampaServ.getStoredParams();
    if(source?.source) {
      if (Object.keys(source).length >= 1) {
        source.fromUrl = window.location.pathname;
        // Comprobar si solo es slash asignar login para mejorar busqueda
        source.fromUrl == '/' ? source.fromUrl = '/login' : source.fromUrl;
        
        // Guardar los datos de analytics en la base de datos
        this.userServ.saveAnalytics(source).subscribe(res => {
          if(res) {
            localStorage.removeItem('source');
          }
        });
      }
    }
  }

  /** Iniciar sesion con biometria */
  async loginWithBiometric() {
    try {
      const credentials = await this.biometricService.getStoredCredentials();

      if (credentials) {
        const isAuthenticated = await this.biometricService.authenticateWithBiometrics();
        if (isAuthenticated) {
          this.biometricService.saveLogout('false').then(() => {
            this.loginAuth(credentials.email, credentials.password);
          });
        } else { }
      } else {
      }
    } catch (error) { }
  }

  redirectToProjects(){
    this.router.navigate([PATH.ROUTE_AVAILABLE_PROJECTS_HOME], { queryParams: { isUserNoAuth: 1 } });
  }

}
